import React, { useEffect, useState } from "react";
import axios from "axios";
import { Credits } from "../../apiconstants/constants";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import LoadingSpinner from "../../helpers/loadingspinner";  
const DiceCredits = () => {
  const [loading, setLoading] = useState(true);
  const [credits, setCredits] = useState(null);
  useEffect(() => {
    const fetchCredits = async () => {
      try {
        setLoading(true);
        const res = await axios.get(Credits.APIURL);
        setCredits(res.data.remainingCredits);
      } catch (err) {
        console.error("Failed to fetch Dice credits", err);
        setCredits(null);
      } finally {
        setLoading(false);
      }
    };

    fetchCredits();
  }, []);

  return (
    <ConsultantLayout>
     <div className="dice-credits-wrapper">
      <div className="dice-credits-card">
        {loading ? (
         <LoadingSpinner />
        ) : (
          <>
            <div className="dice-icon">
              <i className="fa fa-dice"></i>
            </div>
            <div className="dice-title">Remaining Dice Credits</div>
            <div className="dice-count">{credits}</div>
            <div className="dice-sub">Available for Searches</div>
          </>
        )}
      </div>
    </div>
    </ConsultantLayout>
  );
};

export default DiceCredits;
